import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconHouseRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.463 4.155a1 1 0 0 1 1.074 0l7.002 4.456a1 1 0 0 1 .463.843v9.548a1 1 0 0 1-1 1H4.998a1 1 0 0 1-1-1V9.454a1 1 0 0 1 .463-.843l7.002-4.456Zm-5.465 5.848v7.999h12.004v-7.999L12 6.183l-6.002 3.82ZM9.25 13.75a1 1 0 0 1 1-1h3.5a1 1 0 1 1 0 2h-3.5a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconHouseRoundLine);
export default Memo;
